<template>
    <div v-if="image && image.path" class="col-span-1 row-span-1 flex h-full items-start justify-end sm:row-span-2 sm:items-center">
        <div class="group/image relative flex aspect-square w-20 cursor-pointer overflow-hidden rounded bg-gray-50 p-0 sm:w-36 sm:p-2" @click.stop="showImageModal(image.path)">
            <NuxtImg
                :src="image.path"
                class="aspect-square w-full cursor-pointer overflow-hidden rounded mix-blend-multiply"
                :class="!cloudflareImages ? 'h-full object-cover' : 'h-auto object-contain'"
                loading="lazy"
                fit="cover"
                width="144"
                height="144" />
            <div class="absolute inset-0 flex items-center justify-center overflow-hidden rounded bg-white/0 transition-all sm:group-hover/image:bg-white/70">
                <div
                    class="flex size-10 scale-0 items-center justify-center rounded-full bg-primary text-xl text-white opacity-0 transition-all sm:group-hover/image:scale-100 sm:group-hover/image:opacity-100">
                    <Icon :icon="IconSearch" :auto-align="false" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ImageProps } from '~/types/local-types'
    import { useModal } from 'vue-final-modal'
    import IconSearch from '@/assets/icons/search.svg'
    import Icon from '~/components/Icon.vue'
    import ModalImage from '~/components/Modal/ModalImage.vue'
    import { blockScroll, unBlockScroll } from '~/composables/blockScroll'
    defineProps<ImageProps>()
    const { public: { cloudflareImages } } = useRuntimeConfig()
    function showImageModal (src: string) {
        const imageModalInstance = useModal({
            component: ModalImage,
            attrs: {
                src,
                onBeforeOpen () {
                    blockScroll(window.scrollY)
                },
                onBeforeClose () {
                    unBlockScroll()
                },
                onClose () {
                    imageModalInstance.close()
                }
            }
        })
        imageModalInstance.open()
    }
</script>
